import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function VerifiedPopup() {
  const buyers = [{
    name: 'Mariana C.',
    city: 'San Luis',
    time: '13'
  }, {
    name: 'Roberto P.',
    city: 'Mar del Plata',
    time: '5'
  }, {
    name: 'Florencia M.',
    city: 'La Plata',
    time: '1'
  }, {
    name: 'Sebastián D.',
    city: 'Bahía Blanca',
    time: '8'
  }, {
    name: 'Carolina T.',
    city: 'San Juan',
    time: '3'
  }, {
    name: 'Lucas R.',
    city: 'Mendoza',
    time: '21'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  useEffect(() => {
    if (isClosed) return;
    // Initial delay before showing first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through buyers every 30 seconds
    const cycleTimer = setInterval(() => {
      setIsVisible(false); // Hide current
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % buyers.length);
        setIsVisible(true); // Show next
      }, 1000); // Wait 1s before showing next to allow exit animation
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, [isClosed, buyers.length]);
  if (isClosed) return null;
  const currentBuyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-321">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 w-72 flex gap-4 items-start" data-id="element-322">
          <button onClick={() => setIsClosed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xs p-1" aria-label="Cerrar" data-id="element-323">
            ✕
          </button>

          <div className="w-10 h-10 rounded-full bg-green-100 text-green-600 flex items-center justify-center shrink-0 mt-1" data-id="element-324">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-325">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-326"></path>
            </svg>
          </div>

          <div data-id="element-327">
            <p className="text-xs text-gray-500 font-medium mb-1" data-id="element-328">
              Compra verificada
            </p>
            <p className="text-sm font-bold text-navy-900 leading-tight" data-id="element-329">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-700 mt-1" data-id="element-330">
              compró MegaPack Piano Listo PREMIUM 🏆
            </p>
            <p className="text-xs text-gray-400 mt-2" data-id="element-331">
              hace {currentBuyer.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}